import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon, Ornament, Watermark, ArchImage } from '../ui';
import BookingWidget from './BookingWidget';
import UspRow from './UspRow';
import LiveDarshanCard from './LiveDarshanCard';

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section className="hero">
      <Watermark variant="mandala" position="top-left" />
      <Watermark variant="mandala" position="bottom-right" />
      <div className="container">
        <div className="hero__grid">
          <div className="hero__copy">
            <p className="hero__pre">{t('Experience the')}</p>
            <h1 className="hero__title">{t('Divine Ayodhya')}</h1>
            <p className="hero__sub">
              <span>{t('The Eternal Abode of Lord Shri Ram')}</span>
              <Ornament />
            </p>
            <p className="lead hero__lead">
              {t('Plan your spiritual journey — book darshan, aarti, seva, stay and more, all in one blessed place.')}
            </p>
            <div className="hero__actions">
              <Button size="lg" to="/travel-guide" icon={<Icon name="arrow-right" size={18} />}>{t('Plan Your Visit')}</Button>
              <Button size="lg" variant="outline" to="/about" icon={<Icon name="circle-play" size={18} />}>{t('Explore Ayodhya')}</Button>
            </div>
            <UspRow />
          </div>

          <div className="hero__media">
            <ArchImage src="/images/design/hero-ram-mandir.webp" alt={t('Shri Ram Janmabhoomi Mandir, Ayodhya')} ratio="16/11" />
            <LiveDarshanCard />
          </div>
        </div>

        <div className="hero__widget">
          <BookingWidget />
        </div>
      </div>
    </section>
  );
}
